const DropIcon = ({ size = 48, className = "", ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M38 22V18C38 16.9391 37.5786 15.9217 36.8284 15.1716C36.0783 14.4214 35.0609 14 34 14H18C16.9391 14 15.9217 14.4214 15.1716 15.1716C14.4214 15.9217 14 16.9391 14 18V34C14 35.0609 14.4214 36.0783 15.1716 36.8284C15.9217 37.5786 16.9391 38 18 38H22"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 6V6.02M14 6V6.02M22 6V6.02M30 6V6.02M6 14V14.02M6 22V22.02M6 30V30.02M26 26L44 32L36 36L32 44L26 26Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DropIcon;
